import { render, staticRenderFns } from "./FuncionarioPermissoes.vue?vue&type=template&id=76fea478"
import script from "./FuncionarioPermissoes.vue?vue&type=script&lang=js"
export * from "./FuncionarioPermissoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports